import React from "react";


export interface Alert {
  id: number;
  company_name: string;
  company_symbol: string;
  sector_name: string;
  timestamp: string;
  primary_timeframe: string;
  signal_type: string;
  aligned_frames: string[];
  overall_score: number;
  alert_message: string;
  status: string;
  current_price: number;
  day_change: number;
}

interface RecentAlertsProps {
  alerts: Alert[] | any;
  onAlertClick: (alertId: number) => void;
}



const RecentAlerts: React.FC<RecentAlertsProps> = ({
  alerts,
  onAlertClick,
}) => {
 
  const safeAlerts: Alert[] = Array.isArray(alerts) ? alerts : [];

  const getSignalColor = (signal: string) => {
    switch (signal?.toLowerCase()) {
      case "bullish":
        return "success";
      case "bearish":
        return "danger";
      default:
        return "warning";
    }
  };

  const getStatusColor = (status: string) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return "warning";
      case "sent":
        return "info";
      case "dismissed":
        return "light";
      default:
        return "dark";
    }
  };


  return (
    <div className="box recent-alerts mb-5">
 
      <div className="level mb-4">
        <div className="level-left">
          <h2 className="title is-5">
            <span className="icon">
              <i className="fa fa-bell" />
            </span>
            <span>Recent Alerts</span>
          </h2>
        </div>

        <div className="level-right">
          <span className="tag is-info is-light">
            {safeAlerts.length} alerts
          </span>
        </div>
      </div>


      {safeAlerts.length === 0 ? (
        <div className="notification is-light has-text-centered">
          <p>No recent alerts</p>
        </div>
      ) : (
        <div className="alerts-list">
          {safeAlerts.map((alert) => (
            <div
              key={alert.id}
              className="alert-item box is-clickable"
              onClick={() => onAlertClick(alert.id)}
            >
              <div className="columns is-mobile is-vcentered">
           
                <div className="column is-narrow">
                  <span
                    className={`icon is-large has-text-${getSignalColor(
                      alert.signal_type
                    )}`}
                  >
                    <i
                      className={`fa ${
                        alert.signal_type === "bullish"
                          ? "fa-arrow-trend-up"
                          : alert.signal_type === "bearish"
                          ? "fa-arrow-trend-down"
                          : "fa-minus"
                      } fa-2x`}
                    />
                  </span>
                </div>

           
                <div className="column">
         
                  <div className="level is-mobile mb-2">
                    <div className="level-left">
                      <div>
                        <p className="has-text-weight-bold">
                          {alert.company_name}
                          <span className="tag is-light ml-2">
                            {alert.company_symbol}
                          </span>
                        </p>
                        <p className="is-size-7 has-text-grey">
                          {alert.sector_name}
                        </p>
                      </div>
                    </div>

                    <div className="level-right">
                      <span
                        className={`tag is-${getStatusColor(alert.status)}`}
                      >
                        {alert.status}
                      </span>
                    </div>
                  </div>

                  <p className="mb-2">{alert.alert_message}</p>

                  <div className="level is-mobile">
                    <div className="level-left">
                      <div className="tags has-addons mr-2">
                        <span className="tag is-dark">Score</span>
                        <span className="tag is-warning">
                          {alert.overall_score?.toFixed(1) ?? "0.0"}
                        </span>
                      </div>

                      <div className="tags has-addons mr-2">
                        <span className="tag is-dark">TF</span>
                        <span className="tag is-info">
                          {alert.primary_timeframe}
                        </span>
                      </div>

                      {Array.isArray(alert.aligned_frames) &&
                        alert.aligned_frames.length > 0 && (
                          <div className="tags">
                            {alert.aligned_frames.map((frame, idx) => (
                              <span
                                key={idx}
                                className="tag is-success is-light"
                              >
                                {frame}
                              </span>
                            ))}
                          </div>
                        )}
                    </div>

                    <div className="level-right has-text-right">
                      <p className="has-text-weight-bold">
                        ₹{alert.current_price?.toFixed(2) ?? "N/A"}
                      </p>
                      <p
                        className={`is-size-7 ${
                          alert.day_change >= 0
                            ? "has-text-success"
                            : "has-text-danger"
                        }`}
                      >
                        {alert.day_change >= 0 ? "+" : ""}
                        {alert.day_change?.toFixed(2) ?? "0.00"}%
                      </p>
                    </div>
                  </div>

                  {/* TIME */}
                  <p className="is-size-7 has-text-grey mt-2">
                    {new Date(alert.timestamp).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentAlerts;
